import React from "react";
import { Fade, Slide } from "react-awesome-reveal";

const ProcessSection = () => {
  return (
    <section id="about">
      <div className="section-wrapper mb-[6rem] lg:mb-[8rem]">
        <Fade direction="up" triggerOnce={true} fraction={1}>
          <h2 className="section-heading mb-[4rem] text-[2.75rem] tracking-[-0.25rem] leading-[3.375rem] md:mb-[5rem] md:text-[3.125rem] lg:mb-[7rem] lg:text-[4.375rem] lg:leading-[5rem]">
            How I Work
          </h2>
        </Fade>
        <div className="grid-section grid auto-rows-fr gap-y-[7rem] lg:grid-cols-3 lg:gap-x-[2rem]">
          <div className="process-1-grid flex flex-col">
            <Slide triggerOnce={true} fraction={1}>
              <div className="divider-line border-b-[0.0625rem] border-[#e5e5e5]"></div>
            </Slide>
            <Fade direction="up" triggerOnce={true} fraction={1}>
              <div className="number my-[1rem] leading-[90%] text-[6.25rem] lg:my-[1.5rem] lg:text-[7.5rem] xl:my-[2.5rem] xl:text-[11.25rem] xl:leading-[100%]">
                01
              </div>
            </Fade>
            <Fade
              direction="up"
              cascade
              damping={0.1}
              triggerOnce={true}
              fraction={1}
            >
              <h3 className="grid-heading mb-[0.5rem] tracking-[0] text-[1.375rem] leading-[1.875rem] md:text-[1.5rem] md:leading-[2rem] lg:mb-[0.5rem] lg:text-[1.625] lg:leading-[2.125rem] xl:mb-[1rem] xl:text-[1.75rem]">
                Understand
              </h3>
              <p className="grid-text text-[1rem] leading-[1.5] md:max-w-[26.25rem] lg:max-w-[33.75rem] xl:max-w-[23.75rem]">
                Every successful product starts with understanding the business, the users, and the problem. Before writing code, I focus on the product goals, user journey, and the experience we're trying to create.
              </p>
            </Fade>
          </div>
          <div className="process-1-grid flex flex-col">
            <Slide triggerOnce={true} fraction={1}>
              <div className="divider-line border-b-[0.0625rem] border-[#e5e5e5]"></div>
            </Slide>
            <Fade direction="up" triggerOnce={true} fraction={1}>
              <div className="number my-[1rem] leading-[90%] text-[6.25rem] lg:my-[1.5rem] lg:text-[7.5rem] xl:my-[2.5rem] xl:text-[11.25rem] xl:leading-[100%]">
                02
              </div>
            </Fade>
            <Fade
              direction="up"
              cascade
              damping={0.1}
              triggerOnce={true}
              fraction={1}
            >
              <h3 className="grid-heading mb-[0.5rem] tracking-[0] text-[1.375rem] leading-[1.875rem] md:text-[1.5rem] md:leading-[2rem] lg:mb-[0.5rem] lg:text-[1.625] lg:leading-[2.125rem] xl:mb-[1rem] xl:text-[1.75rem]">
                Build
              </h3>
              <p className="grid-text text-[1rem] leading-[1.5] md:max-w-[26.25rem] lg:max-w-[33.75rem] xl:max-w-[23.75rem]">
                I transform ideas into fast, accessible, and scalable web experiences using modern frontend technologies, always balancing technical quality with usability and performance.
              </p>
            </Fade>
          </div>
          <div className="process-1-grid flex flex-col">
            <Slide triggerOnce={true} fraction={1}>
              <div className="divider-line border-b-[0.0625rem] border-[#e5e5e5]"></div>
            </Slide>
            <Fade direction="up" triggerOnce={true} fraction={1}>
              <div className="number my-[1rem] leading-[90%] text-[6.25rem] lg:my-[1.5rem] lg:text-[7.5rem] xl:my-[2.5rem] xl:text-[11.25rem] xl:leading-[100%]">
                03
              </div>
            </Fade>
            <Fade
              direction="up"
              cascade
              damping={0.1}
              triggerOnce={true}
              fraction={1}
            >
              <h3 className="grid-heading mb-[0.5rem] tracking-[0] text-[1.375rem] leading-[1.875rem] md:text-[1.5rem] md:leading-[2rem] lg:mb-[0.5rem] lg:text-[1.625] lg:leading-[2.125rem] xl:mb-[1rem] xl:text-[1.75rem]">
                Refine
              </h3>
              <p className="grid-text text-[1rem] leading-[1.5] md:max-w-[26.25rem] lg:max-w-[33.75rem] xl:max-w-[23.75rem]">
                Launching isn't the finish line. I continuously improve products by refining user experience, optimizing performance, and making thoughtful iterations based on feedback and real-world usage.
              </p>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
